export default "__VITE_ASSET__ByzJtCag__"